import { jsx as _jsx } from "react/jsx-runtime";
import { TabsHeaderProvider } from '#pplx/frontend/aether/components/Tabs/internal/TabsStructureContext.js';
import { TabsActions } from '#pplx/frontend/aether/components/Tabs/TabsActions.js';
import { TabsList } from '#pplx/frontend/aether/components/Tabs/TabsList.js';
import { Children, isValidElement } from 'react';
const TABS_HEADER_CLASSES = 'border-b border-soft';
const TABS_HEADER_CONTENT_CLASSES = '-mb-px flex items-center justify-between gap-2 px-4';
function validateTabsHeaderChildren(children) {
    const headerChildren = Children.toArray(children);
    const isAllowedChild = (child) => isValidElement(child) && (child.type === TabsList || child.type === TabsActions);
    if (!headerChildren.every(isAllowedChild)) {
        throw new Error('Tabs.Header only accepts Tabs.List and Tabs.Actions children');
    }
    const listCount = headerChildren.filter((child) => isValidElement(child) && child.type === TabsList).length;
    const actionsCount = headerChildren.filter((child) => isValidElement(child) && child.type === TabsActions).length;
    if (listCount !== 1 || actionsCount > 1) {
        throw new Error('Tabs.Header requires one Tabs.List and at most one Tabs.Actions');
    }
    return headerChildren;
}
/**
 * Adds a full-width divider behind an underline tab list and optional Tabs.Actions.
 * Prefer this over `showBottomBorder` when the row needs actions or full-width styling.
 */
export function TabsHeader({ children }) {
    const headerChildren = validateTabsHeaderChildren(children);
    return (_jsx("div", { className: TABS_HEADER_CLASSES, children: _jsx(TabsHeaderProvider, { children: _jsx("div", { className: TABS_HEADER_CONTENT_CLASSES, children: headerChildren }) }) }));
}
//# sourceMappingURL=TabsHeader.js.map